export const ARRAY = 'array';
export const BOOLEAN = 'boolean';
export const COMPONENT = 'component';
export const INTEGER = 'integer';
export const NULL = 'null';
export const NUMBER = 'number';
export const OBJECT = 'object';
export const STRING = 'string';
